import { FormGroup } from "@angular/forms";
import { SettingsService } from "research.web.settings";
var ExperimentDesignFormComponent = /** @class */ (function () {
    function ExperimentDesignFormComponent(settingsService) {
        var _this = this;
        this.settingsService = settingsService;
        this.control = function (controlName) {
            return _this.experimentDesignFormGroup.get(controlName);
        };
        this.settings = this.settingsService.get("_appSettings");
    }
    ExperimentDesignFormComponent.prototype.ngOnInit = function () { };
    Object.defineProperty(ExperimentDesignFormComponent.prototype, "isWheatRequest", {
        get: function () {
            return this.requestDetails.crop === this.settings.wheatCropId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExperimentDesignFormComponent.prototype, "pottingInstructionsEnabled", {
        get: function () {
            var treatments = this.experimentDesignFormGroup.get('treatments');
            return treatments.controls[0].get('pottingInstructions').enabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExperimentDesignFormComponent.prototype, "pollinationInstructionsEnabled", {
        get: function () {
            return this.experimentDesignFormGroup.get('pollinationInstructions').enabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExperimentDesignFormComponent.prototype, "harvestInstructionsEnabled", {
        get: function () {
            return this.experimentDesignFormGroup.get('harvestInstructions').enabled;
        },
        enumerable: true,
        configurable: true
    });
    return ExperimentDesignFormComponent;
}());
export { ExperimentDesignFormComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/experiment-design-form/experiment-design-form.component.ts.pre-build-optimizer.js